var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "700",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "text-h5 font-weight-bold primary secondary--text"
  }, [_vm._v(" Material loan periods & fines ")]), _c('v-card-text', {
    staticClass: "card-text primary--text font-weight-bold"
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "headers": _vm.tableHeaders,
      "hide-default-footer": "",
      "items": _vm.tableData,
      "items-per-page": 50,
      "item-key": "material"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }